export enum IRouterURL {
  BRAND_REDIRECTIONS = '/brand/redirections',
  CATALOG = '/catalog',
  CLIENTS = '/clients',
  CLIENT = '/clients/:id',
  HOME = '/',
  OAUTH_CALLBACK = '/oauth/callback',
  PRODUCT = '/catalog/products/sku/:sku',
  SCA_SELLERS = '/sca-sellers',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '*',
}

export enum ZRouterURL {
  Z_HOME = '/zhome',
  Z_CUSTOMERS = '/zcustomers',
}

enum IRouterNames {
  BRAND_REDIRECTIONS = 'brand-redirections',
  CATALOG = 'catalog',
  CLIENTS = 'clients',
  CLIENT = 'client',
  Z_CUSTOMERS = 'z_customers',
  Z_HOME = 'z_home',
  HOME = 'home',
  OAUTH_CALLBACK = 'oauth-callback',
  PRODUCT = 'product',
  SCA_SELLERS = 'sca-sellers',
  NOT_AUTHORIZED = 'not-authorized',
  NOT_FOUND = 'not-found',
}

export default IRouterNames
